import cn from "classnames";
import { Button, BUTTON_VARIANT } from "components/UI/Button";
import { CheckRound, Close, Shield } from "components/UI/Icons";
import { INFO_VARIANT, InfoProps } from "./Info.types";
import s from "./Info.module.scss";

const ICON_MAP = {
  [INFO_VARIANT.SUCCESS]: CheckRound,
  [INFO_VARIANT.ERROR]: Shield,
};

export const Info = ({ variant, children, onClose, className }: InfoProps) => {
  const Icon = ICON_MAP[variant];

  return (
    <div className={cn(s.info, s[variant], className)}>
      <Icon className={s.icon} />
      <span className={s.content}>{children}</span>
      {onClose && (
        <Button variant={BUTTON_VARIANT.ONLY_ICON_TRANSPARENT} className={s.closeBtn} onClick={onClose}>
          <Close />
        </Button>
      )}
    </div>
  );
};
